:host{display:flex;flex-direction:row;flex:1}.content{display:flex;flex-direction:column;flex:2}.options{display:flex;flex-direction:column;flex:1;align-items:center}
/*# sourceMappingURL=assignment-gap-match-game.component-FS4ZUGMF.css.map */
